import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { UtensilsCrossed, CalendarDays, ShoppingBag, Star, ArrowRight } from "lucide-react";

export default function DashboardOverview({ onNavigate }) {
  const [stats, setStats] = useState({ menu: 0, reservations: 0, orders: 0, reviews: 0 });

  useEffect(() => {
    (async () => {
      const [m, r, o, rv] = await Promise.all([
        api.get("/menu"),
        api.get("/reservations").catch(() => ({ data: [] })),
        api.get("/orders").catch(() => ({ data: [] })),
        api.get("/reviews"),
      ]);
      setStats({ menu: m.data.length, reservations: r.data.length, orders: o.data.length, reviews: rv.data.length });
    })();
  }, []);

  const cards = [
    { tab: "menu", title: "Menu Items", value: stats.menu, icon: UtensilsCrossed, color: "#E69138" },
    { tab: "reservations", title: "Reservations", value: stats.reservations, icon: CalendarDays, color: "#D4AF37" },
    { tab: "orders", title: "QR Orders", value: stats.orders, icon: ShoppingBag, color: "#F2A65A" },
    { tab: "reviews", title: "Reviews", value: stats.reviews, icon: Star, color: "#E69138" },
  ];

  return (
    <div data-testid="overview-section">
      <h1 className="font-serif-display text-4xl text-gold-gradient mb-2">Dashboard</h1>
      <p className="text-sm text-[#D1C7C9] mb-8">Welcome back. Here's a snapshot of Tulsi today.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(({ tab, title, value, icon: Icon, color }) => (
          <button
            key={tab}
            onClick={() => onNavigate(tab)}
            className="bg-[#1A1A1A] border border-[#333] rounded-xl p-5 text-left hover:border-[#E69138]/50 transition-colors group"
            data-testid={`stat-card-${tab}`}
          >
            <div className="flex items-center justify-between mb-3">
              <Icon size={22} style={{ color }} />
              <ArrowRight size={14} className="text-[#666] group-hover:text-[#E69138] group-hover:translate-x-1 transition-all" />
            </div>
            <p className="text-3xl font-serif-display text-[#FDFBF7]">{value}</p>
            <p className="text-xs tracking-[0.2em] uppercase text-[#D1C7C9]/60 mt-1">{title}</p>
          </button>
        ))}
      </div>

      <div className="mt-10 grid lg:grid-cols-2 gap-4">
        <div className="bg-[#1A1A1A] border border-[#333] rounded-xl p-6">
          <h3 className="font-serif-display text-2xl mb-3 text-[#FDFBF7]">Quick Actions</h3>
          <div className="space-y-2">
            <button onClick={() => onNavigate("menu")} className="text-sm text-[#E69138] hover:text-[#F2A65A] block" data-testid="quick-add-menu">+ Add new menu item</button>
            <button onClick={() => onNavigate("gallery")} className="text-sm text-[#E69138] hover:text-[#F2A65A] block" data-testid="quick-add-gallery">+ Upload to gallery</button>
            <button onClick={() => onNavigate("qr")} className="text-sm text-[#E69138] hover:text-[#F2A65A] block" data-testid="quick-gen-qr">+ Generate a table QR code</button>
            <button onClick={() => onNavigate("settings")} className="text-sm text-[#E69138] hover:text-[#F2A65A] block" data-testid="quick-edit-settings">+ Edit home page & social links</button>
          </div>
        </div>
        <div className="bg-[#1A1A1A] border border-[#333] rounded-xl p-6">
          <h3 className="font-serif-display text-2xl mb-3 text-[#FDFBF7]">Reminder</h3>
          <p className="text-sm text-[#D1C7C9]">🇮🇳 Closed on Tuesdays — bookings are automatically blocked.</p>
          <p className="text-sm text-[#D1C7C9] mt-2">💵 Cash-only payment at counter.</p>
        </div>
      </div>
    </div>
  );
}
